import { Box } from "@mui/material";
import DashboardLayout from "../../../../components/global/DashboardLayout";
import DashboardHeader from "../../../../components/global/DashboardHeader";
import BarChart from "../../../../components/BarChart";

const Bar = () => {
  return (
    <DashboardLayout>
      <Box m="20px">
        <DashboardHeader title="Bar Chart" subtitle="Simple Bar Chart" />
        <Box height="70vh">
          <BarChart />
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default Bar;
